import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { AmountDisplay, FiatValueDisplay, useBondingCurve, useHoldings } from '@onomy/react-hub';

import {
  Balances,
  Balance,
  BalancePrice,
  BalanceNumber,
  Hint,
  TooltipCaption,
  TooltipDesc,
} from './SidebarStyles';
import { PrimaryButton } from 'components/Modals/styles';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import { responsive } from 'theme/constants';

const StyledBalances = styled(Balances)`
  @media screen and (max-width: ${responsive.tablet}) and (min-width: ${responsive.smartphoneLarge}) {
    justify-content: space-between;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;

  @media screen and (max-width: ${responsive.tablet}) and (min-width: ${responsive.smartphoneLarge}) {
    margin-top: 0;
    width: 200px;
  }
`;

const Message = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 15px;

  background-color: #252b39;
  border-radius: 4px;

  color: ${props => props.theme.colors.highlightBlue};

  @media screen and (max-width: ${responsive.tablet}) {
    width: 100%;
  }
`;

export default function NOMBalances() {
  const { onomyAddress } = useBondingCurve();
  const { nomTotal, nomUnbonding, nomStaked, loadingStatus } = useHoldings();

  if (loadingStatus.pending) {
    return (
      <Balances>
        <LoadingSpinner />
      </Balances>
    );
  }

  return (
    <StyledBalances>
      {onomyAddress ? (
        <>
          <Balance>
            <BalancePrice>
              <strong>NOM Holdings (Bridged)</strong>
              <BalanceNumber strong>
                <AmountDisplay balance={nomTotal} SymbolComponent={null} decimalPlaces={3} />
                <small>
                  <FiatValueDisplay value={nomTotal.fiatValue} />
                </small>
              </BalanceNumber>
            </BalancePrice>
            <Hint>
              <TooltipCaption>NOM Holdings (Bridged)</TooltipCaption>
              <TooltipDesc>Your total of all NOM Holdings on the Onomy Network</TooltipDesc>
            </Hint>
          </Balance>

          <Balance>
            <BalancePrice>
              <strong>NOM Staked</strong>
              <BalanceNumber strong>
                <AmountDisplay balance={nomStaked} SymbolComponent={null} decimalPlaces={3} />
                <small>
                  <FiatValueDisplay value={nomStaked.fiatValue} />
                </small>
              </BalanceNumber>
            </BalancePrice>
            <Hint>
              <TooltipCaption>NOM Staked</TooltipCaption>
              <TooltipDesc>NOM delegated to earn staking rewards</TooltipDesc>
            </Hint>
          </Balance>

          <Balance>
            <BalancePrice>
              <strong>NOM Locked</strong>
              <BalanceNumber strong>
                <AmountDisplay balance={nomUnbonding} SymbolComponent={null} decimalPlaces={3} />
                <small>
                  <FiatValueDisplay value={nomUnbonding.fiatValue} />
                </small>
              </BalanceNumber>
            </BalancePrice>
            <Hint>
              <TooltipCaption>NOM Locked</TooltipCaption>
              <TooltipDesc>
                Your NOM will become available for use 3 weeks after successful un-delegation.
              </TooltipDesc>
            </Hint>
          </Balance>
        </>
      ) : (
        <Message>View your NOM balance and manage staking after bridging.</Message>
      )}

      <ButtonWrapper>
        <Link to="/validators">
          <PrimaryButton style={{ width: '100%' }}>Manage Staking / Rewards</PrimaryButton>
        </Link>
      </ButtonWrapper>
    </StyledBalances>
  );
}
